import {Component, OnInit} from "@angular/core";
import {TranslatableComponent} from "../../../core/models/TranslatableComponent";
import {TranslateService, TranslatePipe} from "@ngx-translate/core";
import {AlertEnum} from "../../../core/models/Enums/AlertEnum";
import {MatDialogRef, MatDialogContent} from "@angular/material/dialog";
import {ResourceRequestFile} from "../../../core/models/resource-request-file";
import moment from "moment";
import {MessageService} from "../../../core/services/services/message.service";
import {AuthenticationService} from "../../../core/services/services/authentication.service";
import {MatIcon} from "@angular/material/icon";
import {CdkScrollable} from "@angular/cdk/scrolling";
import {FileDragDropComponent} from "../../file-input/components/file-drag-drop/file-drag-drop.component";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatTooltip} from "@angular/material/tooltip";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {EscapeHotkeyDirective} from "../../hotkey/directives/escape-hotkey.directive";
import {SaveHotkeyDirective} from "../../hotkey/directives/save-hotkey.directive";

@Component({
	selector: "app-assets-upload",
	templateUrl: "./assets-upload.component.html",
	styleUrls: ["./assets-upload.component.scss"],
	imports: [
		MatIcon,
		CdkScrollable,
		MatDialogContent,
		FileDragDropComponent,
		ReactiveFormsModule,
		FormsModule,
		MatCheckbox,
		MatTooltip,
		MatFormField,
		MatLabel,
		MatInput,
		EscapeHotkeyDirective,
		SaveHotkeyDirective,
		TranslatePipe,
	],
})
export class AssetsUploadComponent extends TranslatableComponent implements OnInit {
	username: string;

	resourceRequestFile: ResourceRequestFile;

	loading = false;

	constructor(
		protected translate: TranslateService,
		private dialogRef: MatDialogRef<AssetsUploadComponent>,
		private messageService: MessageService,
		private authService: AuthenticationService,
	) {
		super(translate, "AssetsUploadComponent");
		this.dialogRef.addPanelClass("mep-dialog");
	}

	ngOnInit(): void {
		this.resourceRequestFile = new ResourceRequestFile();
		this.resourceRequestFile.visibleOverall = true;
		this.authService.getApplicationUser().then((user) => {
			this.username = user.username;
		});
	}

	save() {
		if (this.resourceRequestFile.file) {
			this.resourceRequestFile.createdAt = moment(new Date()).toISOString();
			this.resourceRequestFile.createdBy = this.username;
			this.resourceRequestFile.name = this.resourceRequestFile.file.name;
			this.dialogRef.close(this.resourceRequestFile);
		} else {
			const message = this._lang("chooseFile");
			this.messageService.add(message, AlertEnum.DANGER);
		}
	}

	onFileChosen(file: File) {
		if (this.fileSizeOk(file)) {
			this.resourceRequestFile.file = file;
		} else {
			this.resourceRequestFile.file = null;
			const message = this.translate.instant("mep.components.files-dialog.failed-file-requirements-size");
			this.messageService.add(message, AlertEnum.WARNING);
		}
	}

	cancel() {
		this.dialogRef.close();
	}

	private fileSizeOk(file: File) {
		const sizeRestriction = 20;
		return file.size / 1024 / 1024 < sizeRestriction;
	}
}
